//
// RecordExtensionStartPanel
//
// Start a new named extended definition for this record (clone).
//

import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useStore } from '../stores'

import { VView } from '../appview'
import { Header, Menu, MenuItem, Property, Text, TextInput } from '../components'
import { validName } from '../utils/text'

export const RecordExtensionStartPanel = observer(function RecordExtensionStartPanel({
    onStart,
    onCancel,
}) {
    const { app } = useStore()
    // Empty by default: omit name so the API assigns "{current} (copy)".
    // make_name rejects spaces/parens, so pre-filling that default would 400.
    const [name, setName] = useState('')

    const _onStart = () => {
        const trimmed = name.trim()
        onStart && onStart(trimmed.length ? trimmed : undefined)
    }

    const _onCancel = () => {
        onCancel && onCancel()
    }

    return (
        <VView className="actions-panel recorddefinition-change-panel">
            <div className="inspector">
                <Header>{app.text('Start new extension')}</Header>
                <Text>
                    {app.text(
                        `The new extension applies to this record only. You can apply it to other siblings from the Extension context-menu later.`
                    )}
                </Text>
                <Property label={app.text('name')}>
                    <TextInput
                        autoConvert={validName}
                        value={name}
                        onChange={e => setName(e.target.value)}
                        onBlur={e => setName(e.target.value.trim())}
                    />
                </Property>
            </div>
            <Menu>
                <MenuItem onClick={_onCancel}>{app.text('Cancel')}</MenuItem>
                <MenuItem onClick={_onStart}>
                    {app.text('Yes, start a new extension')}
                </MenuItem>
            </Menu>
        </VView>
    )
})
